import { ulid } from "ulid"
import { ITrigger, ITriggerJavaData, ITriggerWebConfig, createTriggerUtils } from "@droid/project-v2-interface"
import { timeNamespace } from "../time-namespace"
import { UI } from "./UI"
import { Log } from "@fanfanlo"

const fileLog = new Log(false, "[ITriggerTimeout]")
fileLog.pause = true
fileLog.childrenPaused = true

const type = `${timeNamespace}timeout`
fileLog.log('[ITriggerTimeout] timeNamespace:', timeNamespace)
fileLog.log('[ITriggerTimeout] type:', type)

export interface ITriggerTimeoutJavaData extends ITriggerJavaData {
    time: number
}

export interface ITriggerTimeoutWebConfig extends ITriggerWebConfig {
    // Timeout Trigger 特有的 Web 配置
}

export interface ITriggerTimeoutData extends ITrigger<ITriggerTimeoutJavaData, ITriggerTimeoutWebConfig> {
}

function createDefaultData(): ITriggerTimeoutData {
    fileLog.log('[ITriggerTimeout.createDefaultData] 创建默认数据, type:', type)
    const ulidValue = ulid()
    const defaultData = {
        
        ulid: ulidValue,
        uuid: '',
        ownerUuid: '',
        currentVersion: 0,
        type,
        name: 'triggerTimeout',
        javaData: {
            time: 0
        },
        createdAt: 0,
        updatedAt: 0,
        authorUuid: '',
    }
    fileLog.log('[ITriggerTimeout.createDefaultData] defaultData:', JSON.stringify(defaultData))
    return defaultData
}

function init() {
    fileLog.log('[ITriggerTimeout.init] 初始化')
}

export const triggerTimeoutUtils = createTriggerUtils(type, init, createDefaultData, UI)
